/**
 * Current-time red line indicator for day/week time grids.
 *
 * Isolated component — owns its own 60-second timer to avoid
 * re-rendering the entire grid on every tick.
 *
 * @module components/calendar/NowIndicator
 */

import { useState, useEffect, memo } from 'react'
import { timeToY } from '../../utils/calendarLayout'

const NowIndicator = memo(function NowIndicator({ userTz, hourHeight }) {
  const [now, setNow] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 60_000)
    return () => clearInterval(timer)
  }, [])

  const y = timeToY(now.toISOString(), userTz, hourHeight)

  return (
    <div
      className="absolute left-0 right-0 z-10 pointer-events-none"
      style={{ top: y }}
    >
      <div className="flex items-center">
        <div className="w-2.5 h-2.5 rounded-full bg-red-500 -ml-1 shrink-0" />
        <div className="flex-1 h-0.5 bg-red-500" />
      </div>
    </div>
  )
})

export default NowIndicator
